/* ============================================================
   Alle Sätze der Oberfläche (SPEC §13.7) — EIN Wörterbuch, zusammengesetzt aus
   den Bereichsdateien, damit jedes Paket seine eigene Datei hat (§90.3):

     basis.ts       P0  Schale, Anmeldung, Profil, Nutzer, Fehler     → t.allgemein, t.nav …
     editor.ts      P5  Kataloge, Editor, Stände                        → t.editor.…
     modell.ts      P6  Modell, Import, Zuordnen                        → t.modell.…
     bibliothek.ts  P7  Bibliothek, Admin-Prüfung, KI, Anreicherung     → t.bibliothek.…

   Die Bereiche hängen als EIGENE Äste am Baum (`t.editor`, `t.modell`,
   `t.bibliothek`), nicht flach daneben: so können zwei Pakete denselben
   Schlüsselnamen („titel") benutzen, ohne sich zu überschreiben.

   Warum ein eigenes Wörterbuch und keine i18n-Bibliothek: es gibt eine Sprache (N12),
   und der Gewinn dieser Datei ist ein anderer — jeder Satz, den ein Mensch liest,
   steht an EINER Stelle. Fehlersätze des Servers kommen fertig aus `detail`.

   `useT()` hat dieselbe Form wie in lilasprojekte (`const { t } = useT()`), damit
   kopierte Bausteine unverändert passen.
   ============================================================ */
import { basis } from "./basis";
import { bibliothek } from "./bibliothek";
import { editor } from "./editor";
import { modell } from "./modell";

export const texte = { ...basis, editor, modell, bibliothek };

export type Texte = typeof texte;

/** Für Komponenten. Eine Sprache — also kein Zustand, aber dieselbe Form wie im Haus. */
export function useT(): { t: Texte } {
  return { t: texte };
}

/** Für Stellen außerhalb von React (Auffangkorb, Meldungen aus Hintergrundläufen). */
export const t = texte;
